import styles from "./SearchTrigger.module.scss";
import classNames from "classnames";

type SearchTriggerProps = {
	label: string;
	value?: string;
	error?: boolean;
	isOpen?: boolean;
	onClick: () => void;
	className?: string;
};

export const SearchTrigger = ({
	label,
	value,
	error,
	isOpen,
	onClick,
	className,
}: SearchTriggerProps) => {
	const isFloating = isOpen || !!value;

	const buttonClassName = classNames(styles["search-trigger"], className, {
		[styles["search-trigger--error"]]: error,
		[styles["search-trigger--open"]]: isOpen,
	});

	const labelClassName = classNames(styles["search-trigger__label"], {
		[styles["search-trigger__label--floating"]]: isFloating,
	});

	const handleClick = () => {
		onClick();
	};

	return (
		<button
			type="button"
			className={buttonClassName}
			onClick={handleClick}
			aria-haspopup="dialog"
			aria-expanded={isOpen}
		>
			<div className={styles["search-trigger__content"]}>
				<span className={labelClassName}>{label}</span>

				{value && <span className={styles["search-trigger__value"]}>{value}</span>}
			</div>
		</button>
	);
};
